import { Heading, Paragraph } from '@/atoms/Typography'
import styled from 'styled-components'
import { SwiperSlide } from 'swiper/react'

export const BlogSlider = styled.div`
  padding: ${({ theme }) => theme.rem(32, 0)};

  .swiper {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.rem(32)};
    max-width: 100%;
  }
`

export const BlogSliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(32)};
`

export const ImageContainer = styled.div`
  width: 100%;
  height: 420px;
  position: relative;

  ${({ theme }) =>
    theme.mediaQuery.md(
      `
    height: 360px;
  `,
      true
    )};

  img {
    object-fit: contain;
  }
`

export const StyledSwiperSlide = styled(SwiperSlide)`
  height: auto !important;

  border-right: 1px solid #19456c;

  &:last-child {
    border-right: none;
  }
`

export const BlogSliderTitle = styled(Paragraph)``

export const BlogSliderDescription = styled(Paragraph)``

export const BlogSliderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
`
